import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireTestYourSiteSpeed } from "/Users/ianhobbs/Sites/codey-new-2025/src/assets/js/test-your-site-speed.js";
var testYourSiteSpeedExports = requireTestYourSiteSpeed();
export { testYourSiteSpeedExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(testYourSiteSpeedExports);